/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CrewStatus } from '../../models/crew-status';
import { GetBaseCrewResponse } from '../../models/get-base-crew-response';
import { Rank } from '../../models/rank';
import { Rotation } from '../../models/rotation';

export interface ListBaseCrewUsers$Params {
  id: number;
  startDate: string;
  endDate: string;

/**
 * Matches crew name.
 */
  search?: string;

/**
 * TERTIARY is labeled Territory on this tab.
 */
  rank?: Array<Rank>;
  rotation?: Array<Rotation>;

/**
 * Never-set status is treated as ACTIVE.
 */
  crewStatus?: Array<CrewStatus>;
  page?: number;
  size?: number;
}

export function listBaseCrewUsers(http: HttpClient, rootUrl: string, params: ListBaseCrewUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBaseCrewResponse>> {
  const rb = new RequestBuilder(rootUrl, listBaseCrewUsers.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
    rb.query('search', params.search, {});
    rb.query('rank', params.rank, {"style":"form","explode":true});
    rb.query('rotation', params.rotation, {"style":"form","explode":true});
    rb.query('crewStatus', params.crewStatus, {"style":"form","explode":true});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetBaseCrewResponse>;
    })
  );
}

listBaseCrewUsers.PATH = '/api/scheduler/bases/{id}/crew';
